import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadDefensoriaDto, CreateDefensoriaDto, UpdateDefensoriaDto } from '@/api.types';

export async function GetDefensorias(
  skip: number,
  take: number,
  vara: number = 0,
  comarca: number = 0,
  nome: string | undefined = undefined,
) {
  let where = '0=0';

  if (vara && vara > 0) where = where + ' and vara.id = ' + vara;

  if (comarca && comarca > 0) where = where + ' and comarca.id = ' + comarca;

  if (nome) where = where += ` and defensoria.nome ilike '%${nome}%'`;

  return api
    .get(Endpoints.DEFENSORIA, {
      params: { skip: skip, take: take, where: where },
    })
    .then((response) => {
      return GetApiReturn<ReadDefensoriaDto>(response.data as Array<ReadDefensoriaDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadDefensoriaDto>(error, 'Falha ao listar defensorias.');
      return GetApiReturnError<ReadDefensoriaDto>();
    });
}
// TODO Tentar mover o metodo para cá.
// export function GetListaDefensoriaSelect(defensorias: ReadDefensoriaDto[], nome: string) {
// 	let itens: {
// 		label: string | undefined;
// 		value: number | undefined;
// 		name: string | undefined
// 	}[] = []

// 	if (defensorias) {
// 		itens = []
// 		itens.push(
// 			{
// 				label: '',
// 				value: -1,
// 				name: nome
// 			});
// 		itens = itens.concat(defensorias.map((item) => (
// 			{
// 				label: item.nome,
// 				value: item.id,
// 				name: nome
// 			}
// 		)))
// 		return itens;
// 	}
// }

/**
 * Retorna um defensoria de acordo com id.
 * @param {number} id
 * @returns Usuario ou null.
 */
export async function GetDefensoria(id: number) {
  return api
    .get<ReadDefensoriaDto>(Endpoints.DEFENSORIA + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadDefensoriaDto>(
        error,
        'Falha ao bucar o defensoria.' + id,
      );
    });
}

/**
 * Adiciona ou altera um defensoria, se o id for superior a 0 será um update, caso contrário uma inseração.
 * @param {CreateDefensoriaDto | UpdateDefensoriaDto} defensoria
 * @returns True se salvo, False em caso contrário.
 */
export async function SetDefensoria(defensoria: CreateDefensoriaDto | UpdateDefensoriaDto) {
  if (
    defensoria.id !== null &&
    defensoria.id != undefined &&
    defensoria.id > 0
  ) {
    return api
      .put(Endpoints.DEFENSORIA + '/' + defensoria.id, defensoria as UpdateDefensoriaDto)
      .then(() => {
        return 'Defensoria atualizada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao atualizar o defensoria.',
        );
      });
  } else {
    return api
      .post(Endpoints.DEFENSORIA, defensoria as CreateDefensoriaDto)
      .then(() => {
        return 'Defensoria cadastrada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao cadastrar o defensoria.',
        );
      });
  }
}

/**
 * Apaga um defensoria do sistema.
 * @param {number} id
 * @returns True se apagou, False em caso contrário.
 */
export async function DeleteDefensoria(id: number) {
  return api
    .delete(Endpoints.DEFENSORIA + '/' + id)
    .then(() => {
      return 'Defensoria removida.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover defensoria.');
    });
}

/**
 * Busca as lotações do defensor.
 * @returns Lista de lotações.
 */
export async function GetTitularidades() {
  return api
    .get(Endpoints.DEFENSORIA + '/titularidades')
    .then((response) => {
      return GetApiReturn<ReadDefensoriaDto>(response.data as Array<ReadDefensoriaDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadDefensoriaDto>(error, 'Falha ao buscar o lotações.');
      return GetApiReturnError<ReadDefensoriaDto>();
    });
}
